import { render, staticRenderFns } from "./ui-memory-view.vue?vue&type=template&id=7a2da1fa&"
import script from "./ui-memory-view.vue?vue&type=script&lang=js&"
export * from "./ui-memory-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports